import { render, staticRenderFns } from "./no-inventory-call-to-action.vue?vue&type=template&id=c484843a&scoped=true&"
import script from "./no-inventory-call-to-action.vue?vue&type=script&lang=js&"
export * from "./no-inventory-call-to-action.vue?vue&type=script&lang=js&"
import style0 from "./no-inventory-call-to-action.vue?vue&type=style&index=0&id=c484843a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c484843a",
  null
  
)

export default component.exports